var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm17 4.238-7.928 7.1L4 8.216V18h16V8.238ZM4.511 6l7.55 6.662L19.502 6H4.511Z",
    fill: "#7F7B71"
  })));
};

export { SvgMail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgNEgyMUMyMS4yNjUyIDQgMjEuNTE5NiA0LjEwNTM2IDIxLjcwNzEgNC4yOTI4OUMyMS44OTQ2IDQuNDgwNDMgMjIgNC43MzQ3OCAyMiA1VjE5QzIyIDE5LjI2NTIgMjEuODk0NiAxOS41MTk2IDIxLjcwNzEgMTkuNzA3MUMyMS41MTk2IDE5Ljg5NDYgMjEuMjY1MiAyMCAyMSAyMEgzQzIuNzM0NzggMjAgMi40ODA0MyAxOS44OTQ2IDIuMjkyODkgMTkuNzA3MUMyLjEwNTM2IDE5LjUxOTYgMiAxOS4yNjUyIDIgMTlWNUMyIDQuNzM0NzggMi4xMDUzNiA0LjQ4MDQzIDIuMjkyODkgNC4yOTI4OUMyLjQ4MDQzIDQuMTA1MzYgMi43MzQ3OCA0IDMgNFpNMjAgOC4yMzhMMTIuMDcyIDE1LjMzOEw0IDguMjE2VjE4SDIwVjguMjM4Wk00LjUxMSA2TDEyLjA2MSAxMi42NjJMMTkuNTAyIDZINC41MTFaIiBmaWxsPSIjN0Y3QjcxIi8+Cjwvc3ZnPgo=";